import CRUDReducer from './CRUDReducer';
import participantCRUDActions from '../actions/participant';

const participantCRUDReducer = new CRUDReducer(participantCRUDActions);

export default (state, action) => participantCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/participant.js